var React = require('react');

function ChevronInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.65687 12.6569L7.31372 7L1.65687 1.34315","stroke":"#009696","strokeWidth":"2"}));
}

ChevronInline.defaultProps = {"width":"9","height":"14","viewBox":"0 0 9 14","fill":"none"};

module.exports = ChevronInline;

ChevronInline.default = ChevronInline;
